export * from './footer-small.props';
export * from './footer-small';
